<template>
  <div class="w-full pt-3">
    <span>
      <a
        :href="makePaymentUrl"
        class="btn btn-primary btn-sm !py-[0.375rem] text-base inline cursor-pointer"
        v-html="item.firstLinkContent.value"
      ></a>
    </span>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useAccountStore } from '@/store';
import { InsurancePolicy } from '@/interfaces';

const accountStore = useAccountStore();

const props = defineProps<{
  insurancePolicy: InsurancePolicy;
  item: any;
  selfServiceToggles: any;
}>();

const makePaymentUrl = ref<string>();

onMounted(async () => {
  makePaymentUrl.value = await getMakePaymentUrl();
});

const getMakePaymentUrl = async (): string => {
  const selfServiceMakePaymentUrl = await accountStore.getSelfServiceMakePaymentUrl();
  const paymentReferenceNumber = props.insurancePolicy?.currentTermPaymentDetails?.paymentReferenceNumber;
  return `${selfServiceMakePaymentUrl?.replace('{0}', paymentReferenceNumber)}`;
};
</script>
